// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "content-3buRs";
var _3 = "closeIcon-2SI2f";
var _4 = "sliderRoot-3WS39";
var _5 = "heading-SasOV";
var _6 = "text-2JQSV";
var _7 = "icons-1P96G";
var _8 = "icon-3mXEv";
export { _1 as "__esModule", _2 as "content", _3 as "closeIcon", _4 as "sliderRoot", _5 as "heading", _6 as "text", _7 as "icons", _8 as "icon" }
export default { "__esModule": _1, "content": _2, "closeIcon": _3, "sliderRoot": _4, "heading": _5, "text": _6, "icons": _7, "icon": _8 }
